import React, { useEffect, useState } from 'react'
import ApiService from '../Services/ApiService';

const useObtenerVerificacionCredenciales = () => {
    const { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(false); //setear en true cuando se use el hook
    const [response, setResponse] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        setResponse(false); //TODO: se utiliza cuando se aclare desde suscripciones la validacion
        //    const fetchData = async () => {
        //        ApiService.post(
        //            `${REACT_APP_APIPAYWALL}CredencialV1/ObtenerVerificacionCredenciales`
        //            )
        //            .then((data) => {
        //                 if (data.code == "0000") {
        //                     setResponse(data.response);
        //                 } else {
        //                     setError(true);
        //                 }
        //             })
        //             .catch((error) => {
        //                 setError(true);
        //             })
        //             .finally(() => {
        //                 setIsLoading(false);
        //             });
        //         };
        //      fetchData();   
    }, []);

    return [response, error, isLoading];
}

export default useObtenerVerificacionCredenciales